import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 16px 20px;
  /* NOTE: Hardcode, remove when tokens are added */
  background-color: #0042ff;
  /* NOTE: Hardcode, remove when tokens are added */
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    /* NOTE: Hardcode, remove when tokens are added */
    background-color: #0338be;
  }
`;
export const Body = styled.div `
  display: flex;
`;
export const ActionLabelContainer = styled.div `
  display: flex;
`;
export const ActionIconContainer = styled.div `
  margin-left: 16px;
`;
export const IconContainer = styled.div `
  margin-right: 16px;
`;
